import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { I18nModule } from '@recruitee/i18n';

import { RtUICoreOverlayModule } from '../../core/overlay/overlay.module';
import { DropdownModule } from '../dropdown/dropdown.module';
import { HeadingModule } from '../heading/heading.module';
import { IconHelpModule } from '../icon-help/icon-help.module';
import { TooltipModule } from '../tooltip/tooltip.module';
import { IconHelpWithDropdownComponent } from './icon-help-with-dropdown.component';

@NgModule({
  imports: [
    I18nModule,
    CommonModule,
    IconHelpModule,
    TooltipModule,
    RtUICoreOverlayModule,
    DropdownModule,
    HeadingModule,
  ],
  declarations: [IconHelpWithDropdownComponent],
  exports: [IconHelpWithDropdownComponent],
})
export class RtIconHelpWithDropdownModule {}
export * from './icon-help-with-dropdown.component';
